import { isEmpty } from './obj-utils';

export function getTodayAsDate() {
    return new Date();
}

export function createDate(year, month, day) {
    return new Date(Date.UTC(year, month - 1, day));
}

export function createDateFromExisting(defaultValue) {
    if (defaultValue !== null) {
        const simpleDate = new Date(defaultValue);
        return new Date(Date.UTC(simpleDate.getFullYear(), simpleDate.getMonth(), simpleDate.getDate()));
    }
    return null;
}

export function getDateAsISOString(dateToChange) {
    if (isEmpty(dateToChange)) {
        return dateToChange;
    }

    const simpleDate = new Date(dateToChange);
    const utcDate = new Date(Date.UTC(simpleDate.getFullYear(), simpleDate.getMonth(), simpleDate.getDate()));
    return utcDate.toISOString();
}
